import DemandsContainer from './DemandsContainer.jsx';
import DemandDetail from './DemandDetail.jsx';

export {DemandsContainer, DemandDetail}



// WEBPACK FOOTER //
// ./pages/demands/index.js